<nav #navEl reactiveToolbar style="background-color: var(--bg-color)">
    <div class="app-container flex items-center py-2">
        <a routerLink="/" class="site-logo">
            <img placeholder width="65" height="64" ngSrc="/assets/idris-esen-logo.png" priority class="site-logo" i18n-alt alt="Idris Esen Art" />
        </a>
        <span class="spacer"></span>
        <button class="md:hidden" type="button" (click)="toggleMenu()" id="menu-btn">
            <img placeholder ngSrc="/assets/menu-button.png" alt="menu" width="22" height="22" />
        </button>
        <div class="hidden md:block navbar-links">
            <ng-container *ngTemplateOutlet="navbarLinks"></ng-container>
        </div>
    </div>
</nav>

<!-- set main margin top to be equals to navEl height -->
<main class="main" [style.margin-top.px]="navEl.offsetHeight">
    <!-- [dir]="ls.dir$ | async" -->
    <router-outlet></router-outlet>
</main>
<iea-app-footer></iea-app-footer>

<!-- aria dialog -->
<div #mobMenu class="mob-menu {{ mobMenuStateClass() }}" aria-hidden="true" role="dialog">
    <button (click)="toggleMenu()">
        <img placeholder ngSrc="/assets/close.png" alt="menu" placeholder width="32" height="32" />
    </button>
    <a routerLink="/" (click)="toggleMenu()" style="margin-block-end: clamp(1rem, 8vh, 8rem)">
        <img ngSrc="/assets/idris-esen-logo.png" priority placeholder width="64" height="64" class="w-auto h-32 mx-auto block" i18n-alt alt="Idris Esen Art" />
    </a>
    <ng-container *ngTemplateOutlet="navbarLinks"></ng-container>
</div>

<ng-template #navbarLinks>
    <a class="nav-link nav-item" routerLink="/" [routerLinkActiveOptions]="{ exact: true }" routerLinkActive="active"><span i18n>Home</span></a>
    <a class="nav-link nav-item" routerLink="/about-me" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><span i18n>About Me</span></a>
    @for (category of app.artBoardsTypes | async; track i; let i = $index) {
    <!-- path match prefix -->
    <a class="nav-link nav-item" [routerLink]="['/gallery', category._id]" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }"
        ><span>{{ category.name }}</span></a
    >
    }
</ng-template>
